import { stringify } from 'qs';
import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';
import { async } from 'q';

export async function save(payload) {
  return request(`/iwms-wms/wms/wave`, {
    method: 'POST',
    body: payload,
  });
}

export async function deleteWave(payload) {
  return request(`/iwms-wms/wms/wave/${payload.uuid}?version=${payload.version}`, {
    method: 'DELETE',
  });
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/wave/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function query(payload) {
  return request(`/iwms-wms/wms/wave/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function get(payload) {
  return request(`/iwms-wms/wms/wave/${payload.uuid}`);
}

export async function getByWaveUuid(payload) {
  return request(`/iwms-wms/wms/wave/getByWaveUuid?uuid=${payload.uuid}`);
}

//查询波次单执行进度
export async function getSchedule(payload) {
  return request(`/iwms-wms/wms/wave/${payload.uuid}/schedule`);
}

export async function start(payload) {
  return request(`/iwms-wms/wms/wave/${payload.uuid}/start?version=${payload.version}`, {
    method: 'POST',
  }, true);
}

export async function restart(payload) {
  return request(`/iwms-wms/wms/wave/${payload.uuid}/restart?version=${payload.version}`, {
    method: 'POST',
  }, true);
}

export async function finish(payload) {
  return request(`/iwms-wms/wms/wave/${payload.billNumber}/finish?dcUuid=${loginOrg().uuid}&finishOrder=${payload.finishOrder}`, {
    method: 'POST',
  });
}

export async function execute(payload) {
  return request(`/iwms-wms/wms/wave/${payload.uuid}/execute`, {
    method: 'POST',
  });
}

export async function rollBack(payload) {
  return request(`/iwms-wms/wms/wave/${payload.uuid}/rollBack?version=${payload.version}`, {
    method: 'POST',
  });
}

export async function confirm(payload) {
  let pickReleaseType = payload.pickReleaseType ? payload.pickReleaseType : '';
  let rplReleaseType = payload.rplReleaseType ? payload.rplReleaseType : '';
  return request(`/iwms-wms/wms/wave/${payload.uuid}/confirm?version=${payload.version}&releaseType=${pickReleaseType}&rplReleaseType=${rplReleaseType}`, {
    method: 'POST',
  });
}

export async function finishUnify(payload) {
  return request(`/iwms-wms/wms/wave/${payload.uuid}/finish/unify?version=${payload.version}`, {
    method: 'POST',
  });
}

export async function release(payload) {
  return request(`/iwms-wms/wms/wave/${payload.uuid}/release?version=${payload.version}`, {
    method: 'POST',
  });
}

export async function rplRelease(payload) {
  return request(`/iwms-wms/wms/wave/${payload.uuid}/rplrelease?version=${payload.version}`, {
    method: 'POST',
  });
}

export async function queryStoreInfo(payload) {
  return request(`/iwms-wms/wms/wave/queryStoreInfo?billNumber=${payload.billNumber}&dcUuid=${loginOrg().uuid}`, {
    method: 'GET',
  });
}

export async function modifyOrderItem(payload) {
  return request(`/iwms-wms/wms/wave/modifyOrderItem?billNumber=${payload.billNumber}&dcUuid=${loginOrg().uuid}&storeUuid=${payload.storeUuid}&orderNo=${payload.orderNo}`, {
    method: 'POST',
  });
}

export async function queryWaveDifference(payload) {
  return request(`/iwms-wms/wms/wave/queryWaveDifference?waveBillUuid=${payload.waveBillUuid}&articleCode=${payload.articleCode}&fillRate=${payload.fillRate}`, {
    method: 'GET',
  });
}

export async function queryUnReceivedInfo(payload) {
  return request(`/iwms-wms/wms/wave/queryUnReceivedInfo?billNumber=${payload.billNumber}&dcUuid=${loginOrg().uuid}`, {
    method: 'GET',
  });
}

export async function queryReceiveStockInfos(payload) {
  return request(`/iwms-wms/wms/wave/queryReceiveStockInfos?billNumber=${payload.billNumber}&dcUuid=${loginOrg().uuid}`, {
    method: 'GET',
  });
}

export async function getByNumber(billNumber) {
  return request(`/iwms-wms/wms/wave/${billNumber}/get?dcUuid=${loginOrg().uuid}`);
}

export async function abort(billNumber) {
  return request(`/iwms-wms/wms/wave/${billNumber}/abort?dcUuid=${loginOrg().uuid}`, {
    method: 'POST'
  });
}

export async function addAlcNtcBillsAndStart(payload) {
  return request(`/iwms-wms/wms/wave/${payload.uuid}/addAlcNtcBillsAndStart?version=${payload.version}`, {
    method: 'POST',
    body: payload.alcNtcBillNumbers,
  });
}

export async function likeCrossFinish(payload) {
  return request(`/iwms-wms/wms/wave/${payload.uuid}/finishForLikeCross?version=${payload.version}`, {
    method: 'POST'
  });
}

export async function getDisplayBoard(payload) {
  return request(`/iwms-wms/wms/wave/getDisplayBoard`, {
    method: 'POST',
    body: payload.searchKeyValues,
  });
}

export async function waveArticleReplace(payload) {
  return request(`/iwms-wms/wms/wave/waveArticleReplace`, {
    method: 'POST',
    body: payload
  });
}

export async function pageWaveArticleQty(payload) {
  return request(`/iwms-wms/wms/wave/pageWaveArticleQty`, {
    method: 'POST',
    body: payload,
  });
}

export async function verifyArticleAndStoreGroup(payload) {
  return request(`/iwms-wms/wms/wave/${payload.uuid}/verifyArticleAndStoreGroup`, {
    method: 'GET',
  });
}

export async function queryonlineDifference(payload) {
  return request(`/iwms-wms/wms/wave/queryonlineDifference?waveBillUuid=${payload.waveBillUuid}`, {
    method: 'GET',
  });
}
